export enum Validations {
    REGEX = 'VAL_REGEX',
    MIN_LENGTH = 'VAL_LENGTH_MIN',
    MAX_LENGTH = 'VAL_LENGTH_MAX',
    UPPERCASE = 'VAL_UPPERCASE',
}
